"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsAuctionHouse__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "extended",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "string",
                name: "comment",
                type: "string",
            },
        ],
        name: "AuctionBid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
        ],
        name: "AuctionExtended",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "minBidIncrementPercentage",
                type: "uint256",
            },
        ],
        name: "AuctionMinBidIncrementPercentageUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "reservePrice",
                type: "uint256",
            },
        ],
        name: "AuctionReservePriceUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "winner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AuctionSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "timeBuffer",
                type: "uint256",
            },
        ],
        name: "AuctionTimeBufferUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "auction",
        outputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endTime",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "bidder",
                type: "address",
            },
            {
                internalType: "bool",
                name: "settled",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
        ],
        name: "createBid",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "comment",
                type: "string",
            },
        ],
        name: "createBidWithComment",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "duration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsToken",
                name: "_nouns",
                type: "address",
            },
            {
                internalType: "address",
                name: "_weth",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minBidIncrementPercentage",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract INounsToken",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "reservePrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_minBidIncrementPercentage",
                type: "uint8",
            },
        ],
        name: "setMinBidIncrementPercentage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reservePrice",
                type: "uint256",
            },
        ],
        name: "setReservePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timeBuffer",
                type: "uint256",
            },
        ],
        name: "setTimeBuffer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleCurrentAndCreateNewAuction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "timeBuffer",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "weth",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsAuctionHouse__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsAuctionHouse__factory = NounsAuctionHouse__factory;
NounsAuctionHouse__factory.bytecode = _bytecode;
NounsAuctionHouse__factory.abi = _abi;
